import { makeStyles } from '@material-ui/core/styles';
import MomentsGrid from './MomentsGrid';
import MomentsSettings from './MomentsSettings';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        marginBottom: theme.spacing(3),
    },
}));
interface IMoments {
    config: { [key: string]: any };
    toggleMomentConfigSetting: Function;
    createMomentFilter: Function;
    deleteMomentFilter: Function;
    updateMomentFilter: Function;
}
export default function Moments(props: IMoments) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    function handleChange(event: any, newValue: any) {
        setValue(newValue);
    }

    return (
        <React.Fragment>
            <Paper className={classes.root}>
                <Tabs centered indicatorColor="primary" onChange={handleChange} textColor="primary" value={value}>
                    <Tab label="View all" />
                    <Tab label="Settings" />
                </Tabs>
            </Paper>
            {value === 0 && <MomentsGrid {...props} />}
            {value === 1 && <MomentsSettings {...props} />}
        </React.Fragment>
    );
}
